export default __webpack_public_path__ + "static/media/roadhog.bd89c152.webp";